module.exports = __webpack_public_path__ + "img/burger.fbd7f991.svg";